<template>
	<div id="usuario">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="20">
				<a-input-search
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o nome a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
				>
					<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onNewUsuario"
					:disabled="loading"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Novo Usuário</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="showCliente? columns: columnsSemCliente"
				:rowKey="record => record.idUsuario"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="ativo" slot-scope="ativo, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativo"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>				
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar usuário</template>
							<a-icon 
								type="form" 
								class="cursor" 
								v-if="($store.state.auth.idPerfilPortal == 1 || record.idUsuario != $store.state.auth.idUser)"
								@click="editarUsuario(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>

			<modal-component
				class="modal-component"
				title="Editar Usuário"
				ref="modaluser"
				width="40%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>
					<a-input
						:maxLength=100
						placeholder="Insira o nome do usuário"
						v-model="user.nome"
						v-ant-input-focus
						:allowClear="user.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input 
						:maxLength=100
						placeholder="Insira o e-mail do usuário" 
						v-model="user.email"
						:allowClear="user.email!=''"
						@change="lowerCaseEmail"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login:</span>					
					<a-input 
						:maxLength=50
						placeholder="Insira o login do usuário. (Ex: nome.sobrenome)"
						v-model="user.login"
						:allowClear="user.login!=''"
						@change="lowerCaseLogin"
						:disabled="!ehNovoUsuario"
						readOnly
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<a-col :span="24">
						<span class="tr-label">Tipo Acesso:</span>						
						<a-select
							placeholder="Selecione o tipo acesso do usuário"
							:value="valuePerfilPortal"
							style="width: 100%;"
							@change="handleSelectChange"							
						>
							<a-select-option
								v-for="perfilPortal in perfisPortal"
								:key="perfilPortal.idPerfilPortal"
								:value="perfilPortal.idPerfilPortal"
							>{{perfilPortal.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="habilitarFuncionalidade('PermitirAlterar')">
					<a-col :span="24">
						<span>Cliente:</span>						
						<a-select
							:value="valueCliente"
							style="width: 100%;"
							@change="handleSelectChangeCliente"
							:allowClear="(valueCliente!=null && valueCliente!=undefined)"
						>
							<a-select-option
								v-for="cliente in clientes"
								:key="cliente.idCliente"
								:value="cliente.idCliente"
							>{{cliente.nome}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="valuePerfilPortal==4">
					<span class="tr-label">Gestor Vinculado:</span>
					<a-table
						:rowSelection="rowSelection"
						:columns="columnsModal"
						:rowKey="record => record.idUsuario"
						:dataSource="dataModal"
						:loading="{spinning:loading, tip:'Carregando...'}"
						:pagination="false"
						:scroll="{ y: 450 }"
						size="middle"
					>
						<template slot="customTitleReceberEmail">Receber e-mail&nbsp;&nbsp;&nbsp;
							<a-tooltip>
								<template slot="title">Gestor irá receber cópia dos e-mails de entrega enviados para este usuário</template>
								<a-icon type="info-circle" style="color: #ff0130;"/>
							</a-tooltip>
						</template>

						<template slot="recebeEmail" slot-scope="recebeEmail, record">
							<a href="javascript:;" v-if="record.recebeEmail" @click="handleChangeRecebeEmail(record)">
								<a-icon type="check-square" theme="filled" style="font-size: 18px; color: #1d375c;"/>
							</a>
							<a href="javascript:;" v-else @click="handleChangeRecebeEmail(record)">
								<a-icon type="border" style="font-size: 18px; color: #bfbfbf;"/>
							</a>
						</template>
					</a-table>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="user.ativo" @change="handlerSwitchChange">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;">Situação</span>
							<a-tooltip>
								<template slot="title">Ao desativar o usuário, todos os perfis e fontes vinculados a ele serão desativados consequentemente</template>
								<a-icon type="info-circle" style="margin-left: 10px; color: #ff0130;"/>
							</a-tooltip>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="usuario-form-button" @click.prevent="handleCancelEditUser">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="usuario-form-button"
										type="primary"
										v-if="habilitarFuncionalidade('PermitirAlterar')"
										@click.prevent="handleOkEditUser"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>

			<modal-component
				class="modal-component"				
				title="Novo Usuário"
				ref="modalnewuser"
				width="40%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o nome do usuário"
						v-model="user.nome"
						v-ant-input-focus
						:allowClear="user.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>						
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input 
						:maxLength=100
						placeholder="Insira o e-mail do usuário" 
						v-model="user.email"
						:allowClear="user.email!=''"
						@change="lowerCaseEmail"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login:</span>					
					<a-input
						:maxLength=50
						placeholder="Insira o login do usuário. (Ex: nome.sobrenome)"
						v-model="user.login"
						:allowClear="user.login!=''"
						@change="lowerCaseLogin"
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<a-col :span="24">
						<span class="tr-label">Tipo Acesso:</span>						
						<a-select
							placeholder="Selecione o tipo acesso do usuário"
							style="width: 100%;"
							:value="valuePerfilPortal"
							@change="handleSelectChange"
						>
							<a-select-option
								v-for="perfilPortal in perfisPortal"
								:key="perfilPortal.idPerfilPortal"
								:value="perfilPortal.idPerfilPortal"
							>{{perfilPortal.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="habilitarFuncionalidade('PermitirIncluir')">
					<a-col :span="24">
						<span>Cliente:</span>						
						<a-select
							style="width: 100%;"
							:value="valueCliente"
							placeholder="Selecione um cliente"
							@change="handleSelectChangeCliente"
							:allowClear="(valueCliente!=null && valueCliente!=undefined)"
						>
							<a-select-option
								v-for="cliente in clientes"
								:key="cliente.idCliente"
								:value="cliente.idCliente"
							>{{cliente.nome}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>				
				<a-row v-if="valuePerfilPortal==4">
					<span class="tr-label">Gestor Vinculado:</span>
					<a-table
						:rowSelection="rowSelection"
						:columns="columnsModal"
						:rowKey="record => record.idUsuario"
						:dataSource="dataModal"
						:loading="{spinning:loading, tip:'Carregando...'}"
						:pagination="false"
						:scroll="{ y: 450 }"
						size="middle"
					>
						<template slot="customTitleReceberEmail">Receber e-mail&nbsp;&nbsp;&nbsp;
							<a-tooltip>
								<template slot="title">Gestor irá receber cópia dos e-mails de entrega enviados para este usuário</template>
								<a-icon type="info-circle" style="color: #ff0130;"/>
							</a-tooltip>
						</template>
						
						<template slot="recebeEmail" slot-scope="recebeEmail, record">
							<a href="javascript:;" v-if="record.recebeEmail" @click="handleChangeRecebeEmail(record)">
								<a-icon type="check-square" theme="filled" style="font-size: 18px; color: #1d375c;"/>
							</a>
							<a href="javascript:;" v-else @click="handleChangeRecebeEmail(record)">
								<a-icon type="border" style="font-size: 18px; color: #bfbfbf;"/>								
							</a>
						</template>
					</a-table>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="usuario-form-button" @click.prevent="handleCancelNewUser">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="usuario-form-button"
										type="primary"										
										@click.prevent="handleOkNewUser"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Login",
		dataIndex: "login",
		sorter: (a, b) => a.login.localeCompare(b.login),
		width: "18%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "E-mail",
		dataIndex: "email",
		sorter: (a, b) => a.email.localeCompare(b.email),
		width: "18%",
		scopedSlots: { customRender: "email" }
	},
	{
		title: "Tipo Acesso",
		dataIndex: "perfilPortal.descricao",
		sorter: (a, b) => a.perfilPortal.descricao.localeCompare(b.perfilPortal.descricao),
		width: "10%",
		scopedSlots: { customRender: "perfilPortal" }
	},
	{		
		title: "Cliente",
		dataIndex: "cliente.nome",
		sorter: (a, b) => a.cliente.nome.localeCompare(b.cliente.nome),
		width: "18%",
		scopedSlots: { customRender: "cliente" },		
	},
	{
		title: "Situação",
		dataIndex: "ativo",
		sorter: (a, b) => a.ativo - b.ativo,		
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "ativo" }
	},	
	{
		key: "IdUsuario",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsSemCliente = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Login",
		dataIndex: "login",
		sorter: (a, b) => a.login.localeCompare(b.login),
		width: "22%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "E-mail",
		dataIndex: "email",
		sorter: (a, b) => a.email.localeCompare(b.email),
		width: "22%",
		scopedSlots: { customRender: "email" }
	},
	{
		title: "Tipo Acesso",
		dataIndex: "perfilPortal.descricao",
		sorter: (a, b) => a.perfilPortal.descricao.localeCompare(b.perfilPortal.descricao),
		width: "15%",
		scopedSlots: { customRender: "perfilPortal" }
	},
	{
		title: "Situação",
		dataIndex: "ativo",
		sorter: (a, b) => a.ativo - b.ativo,		
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "ativo" }
	},
	{
		key: "IdUsuario",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsModal = [	
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},	
	{
		//title: "Recebe e-mail",
		dataIndex: "recebeEmail",
		sorter: (a, b) => a.recebeEmail - b.recebeEmail,
		width: "35%",
		align: "center",
		slots: { title: 'customTitleReceberEmail' },
		scopedSlots: { customRender: "recebeEmail" }
	},
];

export default {	
	name: "usuario",
	data() {
		return {
			idTela: 1,
			data: [],
			dataModal: [],
			strSearch: null,
			searchText: "",
			searchInput: null,
			pagination: {},
			loading: false,
			columns,
			columnsSemCliente,
			columnsModal,
			user: {
				idUsuario: 0,
				idUsuarioAlteracao: 0,
				idUsuarioCadastro: 0,
				idCliente:0,
				nome: "",
				login: "",
				email: "",
				senha: "",
				ativo: true,
				idPerfilPortal: 0,
				perfilPortal: {
					idPerfilPortal: 0,
					descricao: "",
					situacao: ""
				},
				cliente:{
					idCliente: 0,
					nome: ""
				},
				primeiroAcesso: 1,
				statusTermoUso: 0,
				listaGestores: []
			},
			perfisPortalCompleto: [],
			perfisPortal: [],
			clientes: [],
			valuePerfilPortal: null,
			valueCliente: null,			
			gestorSelRowsModal: null,
			rowSelection: {
				type:'checkbox',
				onChange: (selectedRowKeys, selectedRows) => {					
					this.rowSelection.selectedRowKeys = selectedRowKeys;
					this.gestorSelRowsModal = selectedRows.length == 0 ? null : selectedRows;
				},
				selectedRowKeys: [],
			},
			ehNovoUsuario: true,
			showCliente: false,
			oldAtivoStatus: true,
			textFilter: ""
		};
	},
	mounted() {
		this.showCliente = this.$store.state.auth.idPerfilPortal == 1;
		this.fetch({ search: true });
		this.recuperarPerfisPortal();		
	},
	methods: {
		lowerCaseLogin() {
            this.user.login = this.user.login.toLowerCase();
        },
		lowerCaseEmail() {
			this.user.email = this.user.email.toLowerCase();
		},
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},		
		fetch(params = {}) {
			this.loading = true;
			if (params.search) {				
				params['idCliente'] = this.$store.state.auth.idCliente;
				IntimacaoWebApi.getUsersExibicao(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Usuário", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Usuário", res.data.result);
					} else {
						this.data = res.data.result;
						this.listarClientes();
						this.pagination = { current: 1 };
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Usuário", "Erro ao tentar carregar usuários.");
				});
			} else {
				this.loading = false;
			}
		},
		listarClientes() {
			IntimacaoWebApi.getListarClientes().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Usuário", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Usuário", res.data.result);
				} else {
					this.clientes = res.data.result;					
					this.data.forEach(c => {
						for (let i = 0; i <= this.clientes.length-1; i++){
							if (c.idCliente != null){
								if (c.idCliente == this.clientes[i].idCliente){
									c.cliente = this.clientes[i];
								}
							}
						}
					});
					if (this.$store.state.auth.idPerfilPortal == 2 ||
							this.$store.state.auth.idPerfilPortal == 3 ||
							this.$store.state.auth.idPerfilPortal == 4){						
					  this.clientes = this.clientes.filter(a => a.idCliente === this.$store.state.auth.idCliente);
					}
				}
			});
		},
		onSearch(text) {
			this.textFilter = text;
			this.fetch({ search: true, Text: this.textFilter });
		},
		editarUsuario(usuario) {			
			this.ehNovoUsuario = false;
			this.gestorSelRowsModal = null;
			this.perfisPortal = this.$store.state.auth.idPerfilPortal > 1 ? this.perfisPortalCompleto.filter(y => {
				return (y.idPerfilPortal == 3 || y.idPerfilPortal == 4);
			}) : this.perfisPortalCompleto;
			this.user.idUsuario = usuario.idUsuario;
			this.user.nome = usuario.nome;
			this.user.login = usuario.login;
			this.user.email = usuario.email;
			this.user.ativo = usuario.ativo;
			this.oldAtivoStatus = usuario.ativo;
			this.user.senha = usuario.senha
			this.valuePerfilPortal = usuario.idPerfilPortal;
			let perfilPortal = this.perfisPortal.filter(x => {
				return x.idPerfilPortal == usuario.idPerfilPortal;
			});			
			if (perfilPortal.length > 0) {
				this.user.perfilPortal.idPerfilPortal = perfilPortal[0].idPerfilPortal;
				this.user.perfilPortal.descricao = perfilPortal[0].descricao;
				this.user.perfilPortal.situacao = perfilPortal[0].situacao;
			}
			this.handleSelectChangeCliente(usuario.idCliente);
			let cliente = this.clientes.filter(x => {
				return x.idCliente == usuario.idCliente
			})
			if (cliente != null && cliente.length >= 1){
				this.user.cliente.idCliente = cliente[0].idCliente;
				this.user.cliente.nome = cliente[0].nome;
			}else{
				this.user.cliente.idCliente = 0;
				this.user.cliente.nome = "";
			}
			this.user.statusTermoUso = usuario.statusTermoUso;
			this.user.listaGestores = usuario.listaGestores;			
			this.$refs.modaluser.showModal();
		},
		onNewUsuario() {
			this.ehNovoUsuario = true;
			this.handleCancelNewUser();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal > 1 ? this.perfisPortalCompleto.filter(y => {
				return (y.idPerfilPortal == 3 || y.idPerfilPortal == 4);
			}) : this.perfisPortalCompleto;
			this.valuePerfilPortal = null;
			this.valueCliente = null;
			if (this.$store.state.auth.idPerfilPortal == 3 || this.$store.state.auth.idPerfilPortal == 4)
			{
				this.handleSelectChangeCliente(this.$store.state.auth.idCliente);
			}			
			this.$refs.modalnewuser.showModal();
		},
		recuperarPerfisPortal() {
			IntimacaoWebApi.getPerfisPortal().then(res => {
				this.perfisPortalCompleto = res.data.result;
				this.perfisPortal = res.data.result;
			});
		},
		handleSelectChange(value) {
			this.valuePerfilPortal = value;
			let perfilPortal = this.perfisPortal.find(p => {
				return p.idPerfilPortal == value;
			});
			this.user.perfilPortal = perfilPortal;
		},
		handleSelectChangeCliente(value) {
			this.valueCliente = value;
			this.user.cliente.idCliente = this.valueCliente;
			this.recuperarGestores(this.valueCliente);			
		},
		handlerSwitchChange(value) {
			this.user.ativo = value;
		},
		validarCampos(user){
			let camposValidos = true;			

			if (this.user.nome.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Nome é um campo obrigatório!");
				camposValidos = false;
			} else if (this.user.email.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Email é um campo obrigatório!");
				camposValidos = false;
			} else if (!Helpers.validarEmail(this.user.email.trim())) {
				showNotificationError(this, "Cadastro de Usuário", "Email com formato inválido!");
				camposValidos = false;
			} else if (this.user.login.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Login é um campo obrigatório!");
				camposValidos = false;
			} else if ((this.user.perfilPortal == undefined) || (this.user.perfilPortal == null) || (this.user.perfilPortal.idPerfilPortal == 0)) {
				showNotificationError(this, "Cadastro de Usuário", "Tipo acesso é um campo obrigatório!");
				camposValidos = false;
			} else if ((this.user.cliente.idCliente == 0) && (this.user.perfilPortal.idPerfilPortal == 3 || this.user.perfilPortal.idPerfilPortal == 4)) {
				showNotificationError(this, "Cadastro de Usuário", "Para o tipo acesso selecionado, o usuário deve ser vinculado a um cliente!");
				camposValidos = false;
			} else if (this.user.cliente.idCliente != 0 && this.user.perfilPortal.idPerfilPortal == 1) {
				showNotificationError(this, "Cadastro de Usuário", "O tipo de acesso 'Administrador' não deve estar associado a nenhum cliente.");
				camposValidos = false;
			} else if (this.user.perfilPortal.idPerfilPortal == 1 && (this.user.email.search(/\b\@kurier\.com\.br\b/i) < 0)) {
				showNotificationError(this, "Cadastro de Usuário", "O tipo de acesso 'Administrador' é exclusivo para colaboradores da Kurier.");
				camposValidos = false;
			} else if ((this.user.perfilPortal.idPerfilPortal == 4) && (this.gestorSelRowsModal == null || this.gestorSelRowsModal.length <= 0)) {
				showNotificationError(this, "Cadastro de Usuário", "Para o tipo acesso selecionado, o usuário deve ser vinculado a um gestor!");
				camposValidos = false;
			}
			return camposValidos
		},
		handleOkEditUser() {			
			if (!this.validarCampos(this.user)){
				return;
			};
			
			if ((this.oldAtivoStatus == true) && (this.user.ativo == false)) {
				const _this = this;
				const x = _this.$createElement;				
				this.$confirm({				
					title: x('div', {}, [
							x('p', "Ao desativar o usuário, todos os perfis e fontes vinculados a ele serão desativados consequentemente."),
						]),					
					content: h => <div style="font-size: 16px; color: #000000d9;">Deseja continuar?</div>,
					okText: 'Sim',        			
        			cancelText: 'Não',
					width: '25%',
					onOk() {
						_this.chamarAPIEditarUsuario();
					},
					onCancel() {},
				});
			} else {
				this.chamarAPIEditarUsuario();
			}
		},
		chamarAPIEditarUsuario() {
			this.$root.loadingSpinner = true;
			this.user.idPerfilPortal = this.user.perfilPortal.idPerfilPortal;
			this.user.idUsuarioAlteracao = this.$store.state.auth.idUser;
			this.user.idCliente = this.user.cliente.idCliente == 0 ? null : this.user.cliente.idCliente;
			this.user.listaGestores = [];
			if ((this.gestorSelRowsModal != null) && (this.gestorSelRowsModal.length > 0)){
				this.gestorSelRowsModal.forEach(g => {
					this.user.listaGestores.push({ idGestor: g.idUsuario, recebeEmail: g.recebeEmail });
				});
			}

			IntimacaoWebApi.atualizarUsuario(this.user, this.$store.state.auth.idUser)
				.then(res => {
					this.handleCancelEditUser();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Usuário", res.data.result);
						this.fetch({ search: true, Text: this.textFilter });
						this.recuperarPerfisPortal();						
					} else
						showNotificationError(this, "Cadastro de Usuário", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Usuário", "Erro ao tentar editar usuário.");
				});
		},
		handleCancelEditUser() {			
			this.$refs.modaluser.handleCancel();
			this.user.idUsuario = 0;
			this.user.idUsuarioAlteracao = 0,
			this.user.idUsuarioCadastro = 0,
			this.user.nome = "";
			this.user.login = "";
			this.user.email = "";
			this.user.senha = "";
			this.user.ativo = true;
			this.user.idPerfilPortal = null;
			this.user.idCliente = null;
			this.user.listaGestores = [];
			this.gestorSelRowsModal = null;
			this.rowSelection.selectedRowKeys = [];
			this.dataModal = [];
		},
		handleOkNewUser() {
			if (!this.validarCampos(this.usuario)){
				return;
			}

			this.user.listaGestores = [];
			if ((this.gestorSelRowsModal != null) && (this.gestorSelRowsModal.length > 0)){
				this.gestorSelRowsModal.forEach(g => {
					this.user.listaGestores.push({ idGestor: g.idUsuario, recebeEmail: g.recebeEmail });
				});
			}

			this.$root.loadingSpinner = true;
			this.user.idPerfilPortal = this.user.perfilPortal.idPerfilPortal;			
			this.user.idUsuarioCadastro = this.$store.state.auth.idUser;
			this.user.ativo = true;
			this.user.idCliente = this.user.cliente.idCliente == 0 ? null : this.user.cliente.idCliente;
			IntimacaoWebApi.inserirUsuario(this.user)
				.then(res => {
					this.$refs.modalnewuser.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Usuário", res.data.result);
					} else {
						showNotificationError(this, "Cadastro de Usuário", res.data.errorMessage);
					}					
					this.fetch({ search: true, Text: this.textFilter });
					this.recuperarPerfisPortal();					
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Usuário", "Erro ao tentar inserir usuário.");
				});
		},
		handleCancelNewUser() {
			this.$refs.modalnewuser.handleCancel();
			this.user.idUsuario = 0;
			this.user.idUsuarioAlteracao = 0,
			this.user.idUsuarioCadastro = 0,
			this.user.nome = "";
			this.user.login = "";
			this.user.email = "";
			this.user.senha = "";
			this.user.ativo = true;
			this.user.listaGestores = [];
			this.gestorSelRowsModal = null;
			this.user.statusTermoUso = 0;
			this.rowSelection.selectedRowKeys = [];
			this.dataModal = [];
		},
		recuperarGestores(idCliente) {			
			this.dataModal = [];
			this.rowSelection.selectedRowKeys = [];
			if (idCliente != undefined && idCliente != null){
				IntimacaoWebApi.getUsuarioCliente(idCliente).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Usuário", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Usuário", res.data.result);
					} else {
						if (res.data.result != null)
						{
							let aux = res.data.result.filter(x => {
								return x.idPerfilPortal == 3;
							});
							this.dataModal = aux.map(h => {
								return {
									idUsuario: h.idUsuario,
									nome: h.nome,
									recebeEmail: false
								}
							});

							if (!this.ehNovoUsuario) {
								let rowKeys = [];
								let selRow = [];
								this.dataModal.forEach(c => {
									for (let i = 0; i <= this.user.listaGestores.length-1; i++){
										if (c.idUsuario != null){
											if (c.idUsuario == this.user.listaGestores[i].idGestor){
												c.recebeEmail = this.user.listaGestores[i].recebeEmail;
												rowKeys.push(c.idUsuario);
												selRow.push(c);
											}
										}
									}
								});
								this.rowSelection.onChange(rowKeys, selRow);
							}
						}						
					}
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Usuário", "Erro ao tentar recuperar gestores.");
				});
			}
		},
		handleChangeRecebeEmail(gestor){
			gestor.recebeEmail = !gestor.recebeEmail;			
		}
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.usuario-form-button {
	width: 100px;
}
</style>